// Sportdings gRPC backend URL, used by the Sportdings frontend's gRPC clients.
//
// Resolution order is runtime env.js value -> CRA build-time override -> production URL.
// Empty values fall through so a misconfigured deployment cannot issue requests to an empty URL.
import { resolveGrpcBackendUrl, runtimeValue } from '@dowty/core';

export const SSO_ENABLED = process.env.REACT_APP_SSO_ENABLED !== 'false';
export const REGISTRATION_ENABLED = process.env.REACT_APP_REGISTRATION_ENABLED === 'true';
export const GRPC_CLIENT_OPTIONS = SSO_ENABLED ? { withCredentials: true } : null;
export const SSO_ISSUER_URL = resolveGrpcBackendUrl(
  // @dowty/core types only its shared keys; this app adds the issuer key to its own env.js.
  runtimeValue('SSO_ISSUER_BASE_URL' as unknown as keyof NonNullable<Window['__RUNTIME_CONFIG__']>),
  process.env.REACT_APP_SSO_ISSUER_BASE_URL,
  'https://sso.dowtex.com',
);

const GRPC_BACKEND_URL = resolveGrpcBackendUrl(
  runtimeValue('GRPC_BACKEND_URL'),
  process.env.REACT_APP_SPORTDINGS_GRPC_BACKEND_URL,
  'https://sportdingsapi2.dowtex.com',
);

export default GRPC_BACKEND_URL;

export const dowtexHubUrl = () => window.location.hostname === 'localhost' ? 'http://localhost:3002' : 'https://dowtex.com';
